module.exports = __webpack_public_path__ + "static/media/icon-check.26f4be1b.svg";